export interface ListItem {
  value: string;
  label: string;
}

interface EnumValues {
  [key: string]: string;
}

export const getEnumAsFilterOptions = (filterOptions: EnumValues) => {
  let list: ListItem[] = [];
  const filterArray = Object.values(filterOptions);

  filterArray.forEach((value: string) => {
    if (value) {
      const listItem = {
        value,
        label: value,
      };
      list.push(listItem);
    }
  });

  return list;
};

export const getSetFilterOptions = (options?: Set<string>) => {
  let list: ListItem[] = [];
  if (options) {
    Array.from(options).forEach((value: string) => {
      if (value) {
        const listItem = {
          value,
          label: value,
        };
        list.push(listItem);
      }
    });
  }
  return list;
};
